import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { ViewOfferButton } from './ViewOfferButton'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import CruiseLuxPlusLabel from 'components/Cruises/CruiseLuxPlusLabel'

interface Props {
  isFlash?: boolean
  roomOccupancy?: string
  priceDetails: App.Pricing
  memberPrice?: number
  canSeeLuxPlusLabel?: boolean
  className?: string
  offerId: string
  variant?: 'default' | 'condensed'
}

function CruisePriceDetails(props: Props) {
  const intl = useIntl()
  const {
    variant = 'default',
    priceDetails,
    memberPrice,
    isFlash,
    roomOccupancy,
    offerId,
    canSeeLuxPlusLabel,
  } = props

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <VerticalSpacer gap={8}>
        <div>
          <PriceRowPriceCaption>{intl.formatMessage({
            id: 'U066vyS-v-9t51qBNa66',
            defaultMessage: 'From',
            description: 'Price caption label preceding the cruise price in the cruises section',
          })}
          </PriceRowPriceCaption>
          <LuxPlusPriceStack
            size="L"
            price={priceDetails.price}
            memberPrice={memberPrice}
            saleUnit={priceDetails.saleUnit}
          />
          {!!priceDetails.value && <PriceRowValueDiscountWithCaption
            size="M"
            originalValue={priceDetails.value}
            discountPercentage={priceDetails.discountPercent}
          />}
          {isFlash && !!roomOccupancy && <PriceRowCaption>{roomOccupancy}</PriceRowCaption>}
        </div>
        {canSeeLuxPlusLabel && <CruiseLuxPlusLabel />}
        <PriceRowAgentHubCommission
          productType={isFlash ? 'cruise-flash' : 'cruise'}
          offerId={offerId}
        />
      </VerticalSpacer>
      <ViewOfferButton variant={variant} />
    </Group>
  )
}

export default CruisePriceDetails
